<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <!-- <div>
                    <el-input placeholder="输入项目名称模糊检索" prefix-icon="el-icon-search"
                              clearable
                              @clear="initOfflineProjects"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initOfflineProjects" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initOfflineProjects" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                    <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button>
                </div> -->
                <div>
                    <!-- <el-upload
                            :show-file-list="false" 
                            :before-upload="beforeUpload"
                            :on-success="onSuccess"
                            :on-error="onError"
                            :disabled="importDataDisabled"
                            style="display: inline-flex;margin-right: 8px"
                            action="/employee/basic/import">
                        <el-button :disabled="importDataDisabled" type="success" :icon="importDataBtnIcon">
                            {{importDataBtnText}}
                        </el-button>
                    </el-upload> -->
                    <!-- <el-button type="success" @click="importData" icon="el-icon-download">
                        {{importDataBtnText}}
                    </el-button>
                    <el-button type="success" @click="exportData" icon="el-icon-download">
                        导出项目
                    </el-button> -->
                    
                    <!-- <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加项目
                    </el-button> -->
                </div>
            </div>

            <!-- 高级搜索条件  -->
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row>
                        <el-col :span="4">
                            项目名称:
                            <el-input v-model="searchValue.keyword" placeholder="项目名称" clearable size="mini"
                                       style="width: 130px;"></el-input>
                        </el-col>
                        <el-col :span="4">
                                年度：<el-date-picker
                                                v-model="searchValue.year"
                                                type="year"
                                                size="mini"
                                                style="width: 125px;"
                                                format="yyyy"
                                                value-format="yyyy"
                                                placeholder="活动时间">
                                        </el-date-picker>
                        </el-col>
                        <el-cal :span="4">
                                项目时间：<el-date-picker
                                                            v-model="searchValue.timeRange"
                                                            type="daterange"
                                                            size="mini"
                                                            style="width: 225px;"
                                                            range-separator="至"
                                                            value-format="yyyy-MM-dd"
                                                            start-placeholder="开始时间"
                                                            end-placeholder="结束时间">
                                                    </el-date-picker>
                        </el-cal>
                        <!-- <el-col :span="7">
                            聘用形式:
                            <el-radio-group v-model="searchValue.engageForm">
                                <el-radio label="劳动合同">劳动合同</el-radio>
                                <el-radio label="劳务合同">劳务合同</el-radio>
                            </el-radio-group>
                        </el-col> -->
                    </el-row>
                    <el-row style="margin-top: 10px" type="flex" justify="end">
                        
   
                        <el-col :span="5" :offset="5">
                            <el-button size="mini">取消</el-button>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="initOfflineProjects('advanced')">搜索</el-button>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <!-- 标题列 --->
        <div style="margin-top: 10px">
            <el-table
                    :data="projects"
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    ref="projectTable"
                    style="width: 100%;"
                    :row-key="row=>row.pCode"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}">
                   
                <!-- <el-table-column
                        type="selection" :reserve-selection="true"
                        width="55">
                </el-table-column> -->
                <el-table-column
                        prop="pName"
                        fixed
                        align="center"
                        label="姓名"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="pId"
                        align="center"
                        label="身份证号"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="pPhone"
                        align="center"
                        label="手机号"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="pCar"
                        align="center"
                        label="车牌号"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="apSTime"
                        align="center"
                        label="进校时间"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="apETime"
                        align="center"
                        label="结束时间"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="waitDay"
                        align="center"
                        label="待审日期"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="passDay"
                        align="center"
                        label="已通过日期"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="refuseDay"
                        align="center"
                        label="被拒日期"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="apStatus"
                        align="center"
                        label="申请状态"
                        width="150">
                        <template slot-scope="scope">
                             {{getChangeType(scope.row.apStatus,'apStatus')}}
                         </template>
                </el-table-column>
                <el-table-column
                        prop="cTime"
                        align="center"
                        label="创建时间"
                        width="180">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        align="center"
                        width="200"
                        label="操作">
                    <template slot-scope="scope">
                        <!-- <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini" type="warning" v-has>锁定</el-button> -->
                        <!-- <el-button style="padding: 3px" size="mini" type="primary">查看高级资料</el-button> -->
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">撤销
                        </el-button>  
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>

        <!-- 上传项目文件弹窗 -->
        <!--================================上传文件弹窗=========================-->
        <el-dialog :title="addFileTitleName" :modal-append-to-body="false"
                :close-on-click-modal="false" :visible.sync="importDataDisabled" width="500px" style="padding:0;" @close="resetAddFile" >
             <div class="add-file-right" >
                <!-- <el-col :span="24">
                    下单平台:<el-select v-model="upFilePlat" clearable="" placeholder="下单平台" size="mini">
                        <el-option
                                v-for="item in platList"
                                :key="item.dictValue"
                                :label="item.dictLabel"
                                :value="item.dictValue">
                        </el-option>
                    </el-select>
                </el-col> -->
            </div>
            <!-- <el-input v-model="addFileName" autocomplete="off" size="small" style="width: 300px; display: none;" ></el-input> -->
           
            <div class="add-file-right" style="margin-top: 20px;">
                <input type="file" ref="clearFile" @change="getFile($event)" multiple="multiplt" class="add-file-right-input" style="margin-left:60px;margin-top: 20px;" accept=".xlsx">
                <div style="margin-top: 20px;">
                    <span class="add-file-right-more">支持扩展名：.xlsx</span>
                </div>
                <div style="margin-top: 10px;">
                    <span class="add-file-right-more">注意：表中必须含有"项目名称"字段,前程和销售单需要注意</span>
                </div>
            </div>
            <div class="add-file-list">
                <ul>
                    <li v-for="(item, index) in addArr" :key="index"><a >{{item.name}}</a></li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddFile" size="small">开始上传</el-button>
                <el-button @click="resetAddFile" size="small">全部删除</el-button>
            </div>
            
        </el-dialog>
    </div>
</template>

<script>
import {Message} from 'element-ui';
    export default {
        
        name: "projectInfo",
        data() {
            return {
               
                searchValue: {
                    year:new Date()
                },
                user:"",
                title: '',
                pCode:'',
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showAdvanceSearchView: false,
                upFilePlat:'',
                addFileTitleName: "上传文件窗口",
                addFileName: "",
                loading: false,
                popVisible: false,
                popVisible2: false,
                dialogVisible: false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
                rules: {
                    detailName: [{required: true, message: '请输入明细名', trigger: 'change'}],
                  
                }
            }
        },
        mounted() {
            this.initOfflineProjects();
        },
        methods: {
            handleSelectionChange (val) {
                console.log(val)
            },
           
            //1、使用插槽（推荐）
            getChangeType(e,z) {

                if('arrivalSituation' == z){
                    for (var i = 0; i < this.arrivalSituationList.length; i++) {
                        if (this.arrivalSituationList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.arrivalSituationList[i].dictLabel;
                        }
                    }
                }else if('detailType' == z){
                        if ('0' == e) { //dictValue，dictLabel保持和上面定义一致
                            return '制作类';
                        }else if('1' == e){
                            return '搭建类';
                        }else if('2' == e){
                            return '运费';
                        }else if('3' == e){
                            return '其他';
                        }
                }else if('apStatus' == z){
                    if ('0' == e) { //dictValue，dictLabel保持和上面定义一致
                            return '待提交';
                        }else if('1' == e){
                            return '部分提交';
                        }else if('2' == e){
                            return '等待审批';
                        }else if('3' == e){
                            return '部分审批';
                        }else if('4' == e){
                            return '审批完成';
                        }
                }
               
            },

            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccess(response, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
                this.initOfflineProjects();
            },
            beforeUpload() {
                this.importDataBtnText = '正在导入';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
            },
            importData(){
                this.importDataDisabled = true;
            },
           
            emptyEmp() {
                this.project = {
                   
                }
                this.inputDepName = '';
            },
         
            showEditEmpView(data) {
                 
                this.title = '编辑项目信息';
                this.project = data;
                // this.inputDepName = data.department.name;
                this.dialogVisible = true;
            },
            deleteDetail(data){
                this.$confirm('此操作将永久删除【' + data.detailName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/yl/offline/detail/" + data.detailCode).then(resp => {
                        if (resp) {
                            this.initDetails();
                            this.initOfflineProjects();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.name + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/employee/basic/" + data.id).then(resp => {
                        if (resp) {
                            this.initOfflineProjects();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
             
            initData() {
                this.user = JSON.parse(window.sessionStorage.getItem("user"));
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initOfflineProjects();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initOfflineProjects('advanced');
            },

            initOfflineProjects(type) {
                this.loading = true;
                // let reqParam = {projectNameLike:this.keyword};
                this.searchValue['projectNameLike']=this.keyword
                this.searchValue['pageNo']=this.page
                this.searchValue['pageSize']=this.size
                this.searchValue['orderByClause']=' c_time desc '
                this.postRequest('/yl/apply/getRecord', this.searchValue).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.projects = resp.data;
                        this.total = resp.total;
                    }
                });



                
            },
            //==================上传文件操作函数=============================================
            getFile(event){  
                //获取上传文件方法    
                var file = event.target.files;    
                for(var i = 0;i<file.length;i++){        
                    //    上传类型判断        
                    var imgName = file[i].name;        
                    var idx = imgName.lastIndexOf(".");        
                    if (idx != -1){            
                        var ext = imgName.substr(idx+1).toUpperCase();            
                        ext = ext.toLowerCase( );            
                        //pdg,doc,docx.xls,.xlsx,.ppt,pptx,            
                        if (ext!='xlsx'){

                        }else{
                            this.addArr.push(file[i]);            
                        }        
                    }else{        

                    }    
                }},
            submitAddFile(){    
                //===========提交上传文件到后台保存方法    
                if(0 == this.addArr.length){        
                    this.$message({            
                        type: 'info',            
                        message: '请选择要上传的文件'        
                    });        
                    return;    
                }    
                var formData = new FormData();    
                for(var i=0;i<this.addArr.length;i++){        
                    formData.append('files',this.addArr[i]); 
                }  
                formData.append('plat',this.upFilePlat);      
                let config = {        
                    headers: { "Content-Type": "multipart/form-data" }    
                };    
                console.log(formData);　　
                //接口请求使用的是自己封装了一下的axios    
                this.postRequest('/yl/qun/importProject', formData, config).then(res => {
                    console.log(res);        
                    this.$message({            
                        message: '操作成功',            
                        type: 'success'        
                    });    
                }).catch((error) => {        
                    alert("操作失败，出现错误：" + error)    
                });
            },
            //清除上传的文件方法
            resetAddFile(){   
                this.addFileName = "";    
                this.addArr =[];
                this.upFilePlat = "";
                this.$refs.clearFile.value =''
            },

        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
    .el-radio{
        margin-top: 8px !important;
    }
    .el-autocomplete-suggestion{
        width: auto!important;
    }
    .el-table__fixed-right {
        height: 100% !important;
    }
    .el-table__fixed{
        height: 100% !important;
    }

</style>
